'use client'
import Button from '@mui/material/Button'
import { ReactNode } from 'react'

interface ScrollButtonProps {
    gotoId?: string
    children?: ReactNode
    [key: string]: any
}

const Index = (props: ScrollButtonProps) => {
    const { gotoId, children, ...rest } = props
    const handleClick = () => {
        const el = document.getElementById(gotoId || 'quota-calculator')
        if (el && el.scrollIntoView) {
            el.scrollIntoView({ behavior: 'smooth' })
        }
    }
    return (
        <Button
            onClick={ handleClick}
            {...rest}
        >
            {children}
        </Button>
    )
}

export default Index


